import moment from 'moment'
import storageService, { STORE_KEY } from 'services/storageService'
import { dateHelper } from './date'

export const bannerHelper = {
  checkShowTeacherBanner,
  checkShowPolicy,
}

function checkShowTeacherBanner() {
  const teacherBanner = storageService.get(STORE_KEY.TEACHER_BANNER)
  if (!teacherBanner || !dateHelper.isSameDay(teacherBanner.timestamp)) {
    storageService.set(STORE_KEY.TEACHER_BANNER, {
      timestamp: moment().unix(),
    })
    return true
  }
  return false
}

function checkShowPolicy() {
  const storageData = storageService.get('policy_banner')
  if (!storageData || (storageData && !dateHelper.isSameDay(storageData.timestamp))) {
    storageService.set('policy_banner', {
      timestamp: moment().unix(),
    })
    return true
  }
  return false
}
